import { useState } from 'react';
import PropTypes from 'prop-types';
import { Fab, Hidden } from '@material-ui/core';
import { Menu as MenuIcon } from '@material-ui/icons';

import useStyles from './styles';
import NavBar from './NavBar';

const NAV_COLLAPSED_KEY = 'pinpeo.nav.collapsed';

function DashboardLayout({ children }) {
  const classes = useStyles();
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  // Persistir el colapso del sidebar (solo preferencia visual)
  const [isNavOpen, setNavOpen] = useState(
    localStorage.getItem(NAV_COLLAPSED_KEY) !== 'true',
  );

  const handleNavOpen = (open) => {
    setNavOpen(open);
    localStorage.setItem(NAV_COLLAPSED_KEY, String(!open));
  };

  return (
    <div className={classes.root}>
      <NavBar
        onMobileClose={() => setMobileNavOpen(false)}
        openMobile={isMobileNavOpen}
        openMenu={isNavOpen}
        onExpand={handleNavOpen}
      />

      {/* Botón flotante de menú en móvil */}
      <Hidden lgUp>
        <Fab
          className={classes.mobileMenuButton}
          onClick={() => setMobileNavOpen(true)}
          size="small"
        >
          <MenuIcon fontSize="small" />
        </Fab>
      </Hidden>

      <div className={classes[isNavOpen ? 'wrapper' : 'wrapperCollapsed']}>
        <div className={classes.contentContainer}>
          <div
            children={children}
            className={classes.content}
          />
        </div>
      </div>
    </div>
  );
}

DashboardLayout.propTypes = {
  children: PropTypes.any,
};

export default DashboardLayout;
